import type { Hook } from './types';

import { useEffect, useState } from 'react';

import { getRemainSeconds } from './utils';

export const useCountDown: Hook = ({
  onRemainSecondsChangeRef,
  targetTimestamp,
}) => {
  const [remainSeconds, setRemainSeconds] = useState<number | null>(null);

  useEffect(() => {
    const {
      cancelAnimationFrame,
      clearInterval,
      requestAnimationFrame,
      setInterval,
    } = window;

    let countDownReqAnimId: number | null = null;
    let countDownTimerId: number | null = null;

    const onRemainSecondsRefresh = () => {
      countDownReqAnimId = requestAnimationFrame(() => {
        const nextRemainSeconds = getRemainSeconds(targetTimestamp);
        if (remainSeconds !== nextRemainSeconds) {
          setRemainSeconds(nextRemainSeconds);
          onRemainSecondsChangeRef?.current?.(nextRemainSeconds);
        }
      });
    };

    if (!targetTimestamp) {
      return;
    }

    onRemainSecondsRefresh();

    countDownTimerId = setInterval(onRemainSecondsRefresh, 1000);

    return () => {
      if (countDownReqAnimId) {
        cancelAnimationFrame(countDownReqAnimId);
      }

      if (countDownTimerId) {
        clearInterval(countDownTimerId);
      }
    };
  }, [remainSeconds, targetTimestamp, onRemainSecondsChangeRef]);

  return {
    remainSeconds,
  };
};
